import { useEffect } from 'react'
import { useVehicleContext } from '../../../../../../../contexts/vehicle.context'
import useUpdateVehicle from './useUpdateVehicle'

const useListenOnVehicleSelect = param => {
  const vehicleState = useVehicleContext()
  const { cartVehicleDB } = vehicleState
  const updateVehicle = useUpdateVehicle({
    ...param,
    cartVehicleDB,
  })

  useEffect(() => {
    if (cartVehicleDB && cartVehicleDB.year && cartVehicleDB.itemId) {
      updateVehicle()
    }
  }, [cartVehicleDB, updateVehicle])
}

export default useListenOnVehicleSelect
